<template>
  <div>
    <div>
      <h1>Transportadoras</h1>
      <transportador-table @rowSelected="transportadorTableRowSelect"></transportador-table>
    </div>
    <div v-if="tableSelectedItem.length">
      <!-- <h1>Listagem de regiões prazo entrega</h1> -->
      <br />
      <h1>Prazos de entrega para {{ tableSelectedItem[0].nomeFantasia }}</h1>
      <br />
      <b-tabs content-class="mt-3">
        <b-tab title="Países" active>
          <app-prazo-entrega-paises v-bind:transportadorId="tableSelectedItem[0].id"></app-prazo-entrega-paises>
        </b-tab>
        <b-tab title="Regiões país">
          <app-prazo-entrega-regioes-pais v-bind:transportadorId="tableSelectedItem[0].id"></app-prazo-entrega-regioes-pais>
        </b-tab>
        <b-tab title="Estados">
          <app-prazo-entrega-estados v-bind:transportadorId="tableSelectedItem[0].id"></app-prazo-entrega-estados>
        </b-tab>
        <b-tab title="Regiões estado">
          <app-prazo-entrega-regioes-estado v-bind:transportadorId="tableSelectedItem[0].id"></app-prazo-entrega-regioes-estado>
        </b-tab>
        <b-tab title="Municípios">
          <app-prazo-entrega-municipios v-bind:transportadorId="tableSelectedItem[0].id"></app-prazo-entrega-municipios>
        </b-tab>
      </b-tabs>
    </div>
    <div v-if="!tableSelectedItem.length">
      <base-alert type="primary">{{ $t("transportador.selecioneUmRegistro") }}</base-alert>
    </div>
  </div>
</template>

<script>
import { BaseAlert } from "src/components";
import PrazoEntregaEstados from "./PrazoEntregaEstados.vue";
import PrazoEntregaMunicipios from "./PrazoEntregaMunicipios.vue";
import PrazoEntregaRegioesEstado from "./PrazoEntregaRegioesEstado.vue";
import PrazoEntregaRegioesPais from "./PrazoEntregaRegioesPais.vue";
import PrazoEntregaPaises from "./PrazoEntregaPaises.vue";
import TransportadorTable from "src/components_rms/company/TransportadorTable.vue";

export default {
  name: "Edit",
  components: {
    BaseAlert,
    "app-prazo-entrega-estados": PrazoEntregaEstados,
    "app-prazo-entrega-municipios": PrazoEntregaMunicipios,
    "app-prazo-entrega-regioes-estado": PrazoEntregaRegioesEstado,
    "app-prazo-entrega-regioes-pais": PrazoEntregaRegioesPais,
    "app-prazo-entrega-paises": PrazoEntregaPaises,
    "transportador-table": TransportadorTable,
  },
  data: function () {
    return {
      tableFields: [
        {
          label: "Selecionado",
          key: "selected",
        },
        {
          label: "Número de documento",
          key: "numeroDocumento",
          sortable: true,
        },
        {
          label: "Nome fantasia",
          key: "nomeFantasia",
          sortable: true,
        },
        {
          label: "Razão Social",
          key: "razaoSocial",
          sortable: true,
        },
      ],
      dataTransportadoras: [],
      tablePerPage: 5,
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
      tableRowCount: 0,
    };
  },
  methods: {
    tableProvider(ctx) {
      this.isBusy = true;
      return this.$api
        .get("/empresa/" + ctx.currentPage + "/" + ctx.perPage)
        .then((data) => {
          const items = data.data.items;
          this.isBusy = false;
          this.tableRowCount = data.data.totalItems;
          return items;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableRowCount = 0;
            return [];
          }
        });
    },
    onRowSelected(items) {
      this.tableSelectedItem = items;
    },
    transportadorTableRowSelect(selectedItems) {
        this.tableSelectedItem = selectedItems;
    },
  },
};
</script>

